import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Input, InputGroup, InputLeftElement, Popover, PopoverBody, PopoverContent, PopoverFooter, PopoverHeader, PopoverTrigger, Text } from '@chakra-ui/react';
import { Button, Checkbox, Dismiss, Icon, Info, Notification, SearchIcon } from '@whitbread-eos/atoms';
import { useTranslation } from 'next-i18next';
import React, { useMemo, useState } from 'react';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function TableFilter(_ref) {
  var popoverTrigger = _ref.popoverTrigger,
    filterKey = _ref.filterKey,
    filterOptions = _ref.filterOptions,
    selectedFilters = _ref.selectedFilters,
    onApplyFilters = _ref.onApplyFilters,
    externalStyles = _ref.externalStyles;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    selection = _useState2[0],
    setSelection = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchTerm = _useState4[0],
    setSearchTerm = _useState4[1];
  var sortedFilterOptions = useMemo(() => {
    return filterOptions.sort();
  }, [filterOptions]);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var numberSelected = Object.keys(selection).filter(key => selection[key]).length;
  var multiSelectionLabel = numberSelected ? t('tableFilter.clearAll') : t('tableFilter.selectAll');
  var matchingFilters = searchTerm.length < 3 ? sortedFilterOptions : sortedFilterOptions.filter(option => option.toLowerCase().includes(searchTerm.toLowerCase()));
  var handleMultiSelection = () => {
    setSelection(current => {
      var updatedSelection = _objectSpread({}, current);
      var newValue = !numberSelected;
      Object.keys(updatedSelection).forEach(key => {
        updatedSelection[key] = newValue;
      });
      return updatedSelection;
    });
  };
  var handleCheckboxValueChanged = (event, option) => {
    setSelection(current => {
      var updatedSelection = _objectSpread({}, current);
      if (updatedSelection[option] !== undefined) {
        updatedSelection[option] = event.target.checked;
      }
      return updatedSelection;
    });
  };
  var handleApplyFilters = () => {
    var selectedFilters = Object.keys(selection).filter(key => selection[key]);
    onApplyFilters(selectedFilters, filterKey);
  };
  var clearAllSelection = () => {
    setSelection(current => {
      var updatedSelection = Object.keys(current).reduce((obj, current) => {
        return _objectSpread(_objectSpread({}, obj), {}, {
          [current]: false
        });
      }, {});
      return updatedSelection;
    });
  };
  var setFilterSelection = () => {
    var updatedSelection = filterOptions.reduce((obj, current) => {
      return _objectSpread(_objectSpread({}, obj), {}, {
        [current]: selectedFilters.includes(current)
      });
    }, {});
    setSelection(updatedSelection);
  };
  return _jsx(Popover, {
    onOpen: setFilterSelection,
    onClose: () => {
      clearAllSelection();
      setSearchTerm('');
    },
    children: _ref2 => {
      var isOpen = _ref2.isOpen,
        onClose = _ref2.onClose;
      return _jsxs(_Fragment, {
        children: [_jsx(PopoverTrigger, {
          children: popoverTrigger(isOpen, filterKey)
        }), _jsxs(PopoverContent, _objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, contentStyles), externalStyles === null || externalStyles === void 0 ? void 0 : externalStyles.contentStyles)), {}, {
          children: [_jsx(PopoverHeader, _objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, headerStyles), externalStyles === null || externalStyles === void 0 ? void 0 : externalStyles.headerStyles)), {}, {
            children: _jsxs(Box, _objectSpread(_objectSpread({}, verticalFlexStyles), {}, {
              gap: 6,
              children: [_jsxs(Box, _objectSpread(_objectSpread({}, headerTopSectionStyles), {}, {
                children: [_jsxs(Box, _objectSpread(_objectSpread({}, verticalFlexStyles), {}, {
                  gap: 2,
                  alignItems: "flex-start",
                  children: [_jsxs(Text, _objectSpread(_objectSpread({}, headerTextStyles), {}, {
                    children: ["".concat(numberSelected, " ").concat(t('tableFilter.selectionCount')), ' ']
                  })), _jsx(Text, _objectSpread(_objectSpread({
                    onClick: handleMultiSelection
                  }, _objectSpread(_objectSpread({}, headerTextStyles), headerTextLinkStyles)), {}, {
                    children: multiSelectionLabel
                  }))]
                })), _jsx(Box, _objectSpread(_objectSpread({
                  as: "button",
                  "data-testid": "TableFilter-PopoverCloseIcon"
                }, closeIconStyles), {}, {
                  onClick: onClose,
                  children: _jsx(Icon, {
                    svg: _jsx(Dismiss, {})
                  })
                }))]
              })), _jsxs(InputGroup, {
                children: [_jsx(InputLeftElement, _objectSpread(_objectSpread({}, inputLeftElementStyles), {}, {
                  pointerEvents: "none",
                  children: _jsx(Icon, {
                    svg: _jsx(SearchIcon, {})
                  })
                })), _jsx(Input, _objectSpread({
                  name: "searchFilters",
                  placeholder: t('tableFilter.search.placeholder'),
                  value: searchTerm,
                  onChange: event => setSearchTerm(event.target.value)
                }, inputElementStyles))]
              })]
            }))
          })), _jsxs(PopoverBody, _objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, bodyStyles), externalStyles === null || externalStyles === void 0 ? void 0 : externalStyles.bodyStyles)), {}, {
            children: [matchingFilters.length > 0 && _jsx(Box, _objectSpread(_objectSpread({}, verticalFlexStyles), {}, {
              gap: 4,
              paddingBottom: 4,
              children: matchingFilters.map((filter, index) => {
                var _selection$filter;
                return _jsx(Checkbox, _objectSpread(_objectSpread({
                  isChecked: (_selection$filter = selection[filter]) !== null && _selection$filter !== void 0 ? _selection$filter : false,
                  onChange: e => {
                    handleCheckboxValueChanged(e, filter);
                  },
                  checkboxWrapperStyles: {
                    margin: '0'
                  }
                }, checkBoxStyles), {}, {
                  children: _jsxs(Text, _objectSpread(_objectSpread({}, checkBoxLabelStyles), {}, {
                    children: [filter, " "]
                  }))
                }), "".concat(filter, "-").concat(index));
              })
            })), !!filterOptions.length && !matchingFilters.length && _jsx(Notification, {
              maxWidth: "full",
              variant: "info",
              status: "info",
              description: t('tableFilter.search.noResults'),
              svg: _jsx(Info, {}),
              wrapperStyles: notificationStyles
            })]
          })), _jsx(PopoverFooter, _objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, footerStyles), externalStyles === null || externalStyles === void 0 ? void 0 : externalStyles.footerStyles)), {}, {
            children: _jsx(Button, _objectSpread(_objectSpread({
              onClick: () => {
                handleApplyFilters();
                onClose();
              },
              size: "full",
              variant: "tertiary"
            }, footerButtonStyles), {}, {
              children: t('tableFilter.apply')
            }))
          }))]
        }))]
      });
    }
  });
}
var contentStyles = {
  display: 'flex',
  inset: 'var(--chakra-space-4) auto auto 0px',
  boxShadow: '0px 2px 12px 0px var(--chakra-colors-lightGrey2)',
  padding: '0',
  borderRadius: 'var(--chakra-radii-base)',
  _focus: {
    boxShadow: '0px 2px 12px 0px var(--chakra-colors-lightGrey2)'
  },
  _focusVisible: {
    outline: 'none'
  }
};
var headerStyles = {
  border: 'none',
  padding: 'var(--chakra-space-6) '
};
var headerTopSectionStyles = {
  width: 'full',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between'
};
var bodyStyles = {
  padding: '0',
  margin: '0 var(--chakra-space-6) ',
  flex: '1',
  overflow: 'auto'
};
var footerStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderTop: '1px solid var(--chakra-colors-lightGrey2)',
  padding: 'var(--chakra-space-6) 0'
};
var headerTextStyles = {
  color: 'darkGrey1',
  fontSize: 'md',
  lineHeight: '3',
  fontWeight: 'normal'
};
var headerTextLinkStyles = {
  textDecoration: 'underline',
  cursor: 'pointer',
  marginTop: '0'
};
var closeIconStyles = {
  paddingY: 'var(--chakra-space-1-5)'
};
var inputLeftElementStyles = {
  top: 'var(--chakra-space-4)',
  left: 'var(--chakra-space-4)',
  height: 'var(--chakra-sizes-6)',
  width: 'var(--chakra-sizes-6)'
};
var inputElementStyles = {
  fontSize: 'md',
  lineHeight: '3',
  color: 'darkGrey2',
  height: 'var(--chakra-sizes-14)',
  paddingLeft: 'var(--chakra-space-3xl)',
  paddingTop: 'var(--chakra-space-2)',
  paddingBottom: 'var(--chakra-space-2)',
  borderRadius: 'var(--chakra-radii-base)',
  border: '1px solid var(--chakra-colors-lightGrey1)',
  _placeholder: {
    color: 'darkGrey2'
  },
  _disabled: {
    opacity: '0.4',
    cursor: 'not-allowed'
  }
};
var checkBoxStyles = {
  display: 'flex',
  alignItems: 'center'
};
var checkBoxLabelStyles = {
  color: 'darkGrey1',
  fontSize: 'md',
  fontWeight: '400',
  lineHeight: '3',
  fontFamily: 'header'
};
var footerButtonStyles = {
  margin: '0 var(--chakra-space-6)'
};
var verticalFlexStyles = {
  display: 'flex',
  flexDirection: 'column'
};
var notificationStyles = {
  width: 'auto',
  margin: 0
};
export default TableFilter;